export default __webpack_public_path__ + "media/icons/body-icon-827ba14e.png";